export const APP_PUBLIC_URL = process.env.REACT_APP_PUBLIC_URL;

export const ROUTES = {
  HOME: '/',
  SUCCESS: '/powodzenie',
  PLATE_NUMBER_ERROR: '/blad/numer-rejestracyjny',
  LOCALIZATION_ERROR: '/blad/lokalizacja',
  NOT_FOUND: '*',
} as const;

export type AppRoutes = (typeof ROUTES)[keyof typeof ROUTES];
